module.exports = "/static/assets/69e164fac0cca66c053ecb31c9c2aa64.png";